<template>
  <div class="navbar-box">
    <div class="navbar">
      <div class="logo">
        <img src="../../assets/youzhi_logo.png" alt="Logo" />
      </div>
      <div class="nav-links">
        <span @click="goPage(1)" :class="current == 1 ? 'active' : 'no-active'"
          >首页</span
        >
        <span @click="goPage(2)" :class="current == 2 ? 'active' : 'no-active'"
          >服务</span
        >
        <span @click="goPage(3)" :class="current == 3 ? 'active' : 'no-active'"
          >联系我们</span
        >
        <!-- <router-link to="/index">首页</router-link>
        <router-link to="/services">服务</router-link>
        <router-link to="/contact">联系我们</router-link> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Navbar",
  data() {
    return {
      current: 1,
    };
  },

  methods: {
    goPage(num) {
      console.log("---------", num);
      this.current = num;
      let topNum = 0;
      switch (num) {
        case 1: {
          topNum = 0;
          break;
        }
        case 2: {
          topNum = 1100;
          break;
        }
        case 3: {
          topNum = 2200;
          break;
        }
      }
      window.scrollTo({
        top: topNum,
        left: 0,
        behavior: "smooth",
      });
    },
  },
};
</script>
<style scoped>
.navbar-box {
  position: fixed;
  margin: 0 auto;
  width: 100vw;
  height: 15vh;
  z-index: 9999;
}

.navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  background-color: #fff;
  padding-right: 20vw;
  /* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); */
}

.logo img {
  width: 150px;
}
.no-active {
  margin: 0 15px;
  text-decoration: none;
  font-size: 16px;
  color: black;
  cursor: pointer;
}

.active {
  margin: 0 15px;
  text-decoration: none;
  font-size: 16px;
  color: #e74c3c;
  cursor: pointer;
}

.router-link-active,
.router-link-exact-active {
  font-weight: bold;
  color: #e74c3c !important;
}
</style>
